import './WorkspaceActionsInfo.scss';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { ReactElement, useState } from 'react';
import { WorkspaceActionsModal } from './modal/WorkspaceActionsModal';

export const WorkspaceActionsInfo = (): ReactElement => {
  const { t } = useTranslator();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const toggle = (): void => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <Button
        onClick={toggle}
        title={t('teams.workspace_actions.tooltip')}
        startDecorator={<FontAwesomeIcon icon={faInfoCircle} />}
      >
        {t('check_workspace_roles')}
      </Button>
      <WorkspaceActionsModal
        show={isModalOpen}
        toggle={toggle}
      />
    </>
  );
};
